module.exports = __webpack_public_path__ + "static/media/story_5.9036bc8c.png";